export const CONTACTS = [
  {
    type: "location",
    icon: "bi-geo-alt-fill",
    title: "Address",
    value: `Ali Abbas Patel (Technical Head)
Lubrichem Oils Private Limited
S.No.37/1, Pisoli Road, Kondhwa
Pune - 411048, Maharashtra, India`,
    link: "",
  },
  {
    type: "phone",
    icon: "bi-telephone-fill",
    title: "Phone",
    value: "WhatsApp: +91 9881470186  Tel: +91 8087081005/6",
    link: "https://wa.me/919881470186",
  },
  {
    type: "email",
    icon: "bi-envelope-fill",
    title: "Email",
    value: "sales@lubrichem.co.in",
    link: "mailto:sales@lubrichem.co.in",
  },
  {
    type: "hours",
    icon: "bi-clock-fill",
    title: "Open Hours",
    value: "Mon – Sat: 9:00 AM – 6:30 PM | Sunday Closed",
    link: null,
  },
];
